// Chrome's page translator (and some browser extensions) rewrite the text
// nodes React rendered — every string gets wrapped in a <font> element React
// knows nothing about. On the next re-render React removes/inserts the nodes
// it *thinks* are there and the browser throws
//   "Failed to execute 'removeChild' on 'Node': The node to be removed is not
//    a child of this node."
// which the ErrorBoundary turns into a dead screen (seen on Artículos right
// after saving a product: the insert succeeded, the list re-render died).
// Make those two calls tolerant — when the node isn't ours, skip it instead of
// throwing — so a translated page degrades to slightly stale text, not a crash.
// Only the error path changes; every legitimate call goes straight through.
// See facebook/react#11538. Must be imported before React renders anything.
if (typeof Node === 'function' && Node.prototype) {
  const warn = (what, node) => {
    if (process.env.NODE_ENV !== 'production') console.warn(`domGuard: ${what} skipped for a foreign node`, node);
  };

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChild(child) {
    if (child && child.parentNode !== this) { warn('removeChild', child); return child; }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBefore(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) { warn('insertBefore', referenceNode); return newNode; }
    return originalInsertBefore.apply(this, arguments);
  };
}
